import React from 'react'
import './button-component.scss'
import { ButtonProps } from '../../types'
import { concatClassName } from '../../utils/helpers'

const Button = ({
  iconVariant = 'left',
  IconComponent,
  text,
  variant,
  handleClick,
  buttonType = 'button',
  isDisabled = false,
  classes,
  dataTestId,
}: ButtonProps) => {
  return (
    <>
      {iconVariant === 'left' && (
        <button
          className={`${variant} btn ${concatClassName(classes)}`}
          type={buttonType}
          onClick={handleClick}
          disabled={isDisabled}
          data-testid={dataTestId}
        >
          {IconComponent ?? null}
          {text}
        </button>
      )}
      {iconVariant === 'right' && (
        <button
          className={`${variant} btn ${concatClassName(classes)}`}
          type={buttonType}
          onClick={handleClick}
          disabled={isDisabled}
          data-testid={dataTestId}
        >
          {text}
          {IconComponent ?? null}
        </button>
      )}
    </>
  )
}
export { Button }
